import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteNav } from './SiteNav';
import { SiteFooter } from './SiteFooter';
/**
 * Scrolls the window to the top whenever the route pathname changes.
 * React Router v6 does not do this by default.
 */
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to next tick so the target element is mounted
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({
            block: 'start'
          });
          return;
        }
        window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-bodybg font-sans text-[#E5E5E5] antialiased" data-id="element-90">
      <ScrollToTop data-id="element-91" />
      <SiteNav data-id="element-92" />
      <main className="flex-1" data-id="element-93">
        <Outlet data-id="element-94" />
      </main>
      <SiteFooter data-id="element-95" />
    </div>;
}